import { httpGatewayService } from '@/modules/common/services';

const resourceTypesRoute = 'v3/scheduling/resource_types';
const resourcesRoute = 'v3/scheduling/resources';

const DEFAULT_PAGE_INDEX = 1;

const fetchResourceTypes = (pageIndex = DEFAULT_PAGE_INDEX, pageSize, sort = 'created_at:desc') => 
  httpGatewayService.get(resourceTypesRoute, {
    page: pageIndex,
    per_page: pageSize,
    sort,
  }).then((res) => res.data?.resource_types);

const fetchResources = (pageIndex = DEFAULT_PAGE_INDEX, pageSize, filter = {}) =>
  httpGatewayService.get(resourcesRoute, {
    page: pageIndex,
    per_page: pageSize,
    sort: 'created_at:asc',
    ...filter,
  }).then((res) => res.data?.resources);


export default {
  fetchResourceTypes,
  fetchResources,
};
